import { SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import * as i0 from "@angular/core";
import * as i1 from "@angular/platform-browser";
export class FileDownloaderService {
    constructor(sanitizer) {
        this.sanitizer = sanitizer;
    }
    downloadFileSingle(data, extension) {
        let mimeType;
        switch (extension) {
            case 'jpeg':
                mimeType = 'image/jpeg';
                extension = ".jpeg";
                break;
        }
        this.createrDownloadLink(data, mimeType, extension);
    }
    createrDownloadLink(data, mimeType, extension) {
        if (data.FileData != null) {
            var blob = this.b64toBlob(data.FileData, mimeType);
            var a = document.createElement("a");
            const sanitizedValue = this.sanitizer.sanitize(SecurityContext.HTML, a.outerHTML);
            if (sanitizedValue) {
                const template = document.createElement('template');
                template.innerHTML = sanitizedValue.trim();
                const parsedElement = template.content.firstChild;
                if (parsedElement) {
                    document.documentElement.appendChild(parsedElement);
                }
            }
            var url = window.URL.createObjectURL(blob);
            a.href = url;
            a.download = data.FileName + extension;
            a.click();
            window.URL.revokeObjectURL(url);
        }
    }
    b64toBlob(b64Data, contentType, sliceSize) {
        contentType = contentType || '';
        sliceSize = sliceSize || 512;
        var byteCharacters = atob(b64Data);
        var byteArrays = [];
        for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
            var slice = byteCharacters.slice(offset, offset + sliceSize);
            var byteNumbers = new Array(slice.length);
            for (var i = 0; i < slice.length; i++) {
                byteNumbers[i] = slice.charCodeAt(i);
            }
            var byteArray = new Uint8Array(byteNumbers);
            byteArrays.push(byteArray);
        }
        var blob = new Blob(byteArrays, { type: contentType });
        return blob;
    }
}
FileDownloaderService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function FileDownloaderService_Factory() { return new FileDownloaderService(i0.ɵɵinject(i1.DomSanitizer)); }, token: FileDownloaderService, providedIn: "root" });
